import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function DistrictModal({
  createDistrict,
  getDistrictList,
  history,
  getSingleDistrict,
  type,
  updateDistrict,
  updateList,
  districtId,
  getProvinceList,
  provinceList
}) {
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    province_id: 65
  });
  const validateForm = useFormValidator(formData, {
    name: 'required',
    code: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createDistrict(formData, ({ data }) => {
        setModal({ isOpen: false });
        getDistrictList();
        history.push(
          `/rpt/settings/property-locations/districts/${_.get(data, 'id')}`
        );
        getSingleDistrict(data.id);
      });
    }

    if (type === 'EDIT') {
      updateDistrict(districtId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getDistrictList();
        history.push(
          `/rpt/settings/property-locations/districts/${_.get(data, 'id')}`
        );
        getSingleDistrict(data.id);
      });
    }


  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  useEffect(() => {
    getProvinceList();
  }, []);

  const provinceOptions = provinceList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <InputMask
              className="form-control"
              mask="99"
              alwaysShowMask={false}
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Province
              &nbsp; {validateForm.renderMessage('province_id')}
            </label>
            <div>
              <Select
                isDisabled
                options={provinceOptions}
                styles={customStyle}
                value={provinceOptions.filter(item => +_.get(formData, 'province_id') === +_.get(item, 'id')) || ''}
              // onChange={handleSelected('province_id')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DistrictModal.defaultProps = {
  type: '',
  updateList: {},
  districtId: '',
}

DistrictModal.propTypes = {
  type: PropTypes.string,
  districtId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  createDistrict: PropTypes.instanceOf(Function).isRequired,
  updateDistrict: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleDistrict: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  provinceList: _.get(api, `${c.GET_PROVINCE_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DistrictModal);
